export const ERROR_WRONG_PASSWORD = 'Incorrect password';
